var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passo_a_passo__aplicacao__item"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }